<template>
  <div class="mpe-grid container w-100">
    <div
      v-if="!isCalendarView"
      class="row">

      <div
        v-for="(mpe, i) in getDisplayMpeList"
        :key="`${i}${mpe.id}`"
        :class="getColumns">

        <grid-item
          @editMpe="editMpe"
          @removeMpe="removeMpe"
          @duplicate="duplicate"
          :dataLoading="isDataLoading(mpe.id)"
          :item="mpe"
          :displayType="listStyle"
          :variant="variant" />

      </div>
      <div v-if="!getDisplayMpeList.length">
        <h5 class="m-3 text-center">
          {{ $t('Campaigns.filterNoResults') }}
        </h5>
      </div>
    </div>

    <campaign-calendar
      v-if="isCalendarView"
      :mpes="getDisplayMpeList"
      ref="mpeCalendar"
      :calendarStyle="getCalendarStyle"
      :campaignPreviewItems="campaignPreviewItems"
      :useCalendarNavigation="useCalendarNavigation"
      :removing="removing"
      :validRange="validRange"
      :buttonText="getButtonText"
      @editMpe="editMpe"
      @setSchedule="setSchedule"
      @removeMpe="removeMpe"
      @duplicate="duplicate"
      @changeDate="changeDate"
      :viewedMonth="viewedMonth"
      :variant="variant" />

  </div>
</template>

<script>
import GridItem from '@/components/service/campaignManager/mpeGrid/GridItem'
import CampaignCalendar from '@/components/standard/display/CampaignCalendar'
import paramExtractor from '@/assets/modules/channels/paramExtractor'
import resolver from '@/assets/modules/error/resolver'

import moment from 'moment'

export default {
  data () {
    return {
      editing: null
    }
  },

  methods: {
    /**
     * Tells if data is loading for current mpe grid item
     * @param {String} id
     * @returns {Boolean}
     */
    isDataLoading (id) {
      return !!this.removing[id]
    },

    /**
     * Emots event to change viewed date
     * @param {Object} e
     */
    changeDate (e) {
      this.$emit('changeDate', e)
    },

    /**
     * Requests event's editor
     * @param {Object} e
     */
    editMpe (e) {
      this.$emit('editMpe', e)
    },

    /**
     * Requests schedule update
     * @param {Object}
     */
    setSchedule (e) {
      this.$emit('setSchedule', e)
    },

    /**
     * Requests event removal
     * @param {Object}
     */
    removeMpe (e) {
      this.$emit('removeMpe', e)
    },

    /**
     * Requests event duplication
     * @param {Object}
     */
    duplicate (e) {
      this.$emit('duplicate', e)
    }
  },

  computed: {
    /**
     * Goves calendar's button texts
     * @returns {Object}
     */
    getButtonText () {
      return {
        today: this.$t('Button.today')
      }
    },

    /**
     * Gives grid's column scale based on display style
     * @returns {String}
     */
    getColumns () {
      let base = 'col-12'
      if (this.listStyle !== 'list') {
        base += ' col-md-4 col-lg-3'
      }
      return base
    },

    /**
     * Gives mpe display list - filteres out special events
     * @returns {Array}
     */
    getDisplayMpeList () {
      let rtr = []
      for (let mpe of this.listItems) {
        if (!mpe.special) {
          rtr.push(mpe)
        }
      }
      return rtr
    },

    /**
     * Gives calendar's display style
     * @returns {String}
     */
    getCalendarStyle () {
      switch (this.listStyle) {
        case 'month':
          return 'month'

        case 'agendaWeek':
          return 'agendaWeek'

        case 'week':
          return 'agendaWeek'

        default:
          return this.listStyle
      }
    },

    /**
     * Tells if current view is a calendar view
     * @returns {Boolean}
     */
    isCalendarView () {
      return resolver.isCalendarView(this.listStyle)
    }
  },
  props: {
    validRange: {
      type: Object,
      required: false,
      default: null
    },

    removing: {
      type: Object,
      required: false,
      default: () => { return {} }
    },
    useCalendarNavigation: {
      type: Boolean,
      required: false,
      default: false
    },
    viewedMonth: {
      type: String,
      required: false,
      default: moment(new Date()).format()
    },
    listStyle: {
      type: String,
      required: false,
      default: null
    },
    listItems: {
      type: Array,
      default: () => []
    },
    variant: {
      type: String
    },
    campaignPreviewItems: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    'grid-item': GridItem,
    'campaign-calendar': CampaignCalendar,
  }

}
</script>

<style scoped>
.mpe-grid {
  padding: 7px 15px;
}

</style>



// WEBPACK FOOTER //
// src/components/service/campaignManager/MpeGrid.vue?60b1481c